import { red } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: 16,
    textTransform: 'uppercase',
  },
  isInDueTime: {
    backgroundColor: '#d2ebd3',
    color: '#4caf50',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
  },
  isntInDueTime: {
    backgroundColor: '#f9a19b',
    color: '#f44336',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
  },
  dueTime: {
    backgroundColor: '#cdebfa',
    color: '#1ca5e8',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
  },
  general: {
    backgroundColor: '#eceff1',
    color: '#869ca6',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
  },
  title: {
    color: '#78909c',
    fontWeight: 500,
    fontSize: 16,
  },
  description: {
    fontSize: 14,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  buttonReprove: {
    background: red[700],
    color: '#ffffff',
    '&:hover': {
      backgroundColor: red[900],
    },
  },
}));

export default useStyle;
